import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {WorkVisit} from '../models/workVisit';

@Injectable()
export class WorkVisitService {

  constructor(private httpClient: HttpClient) {
  }

  addOrEditWorkVisit(workVisit, isAdd): Observable<WorkVisit> {
    if (isAdd) {
      return this.httpClient.post<WorkVisit>(environment.baseUrlWs + '/api/work-visit', workVisit);
    }
    return this.httpClient.put<WorkVisit>(environment.baseUrlWs + '/api/work-visit/edit/' + workVisit.id, workVisit);
  }

  getAssignmentWorkVisits(assignmentId: string): Observable<WorkVisit[]> {
    return this.httpClient.get<WorkVisit[]>(environment.baseUrlWs + '/api/assignment-work-visits/' + assignmentId);
  }

  getCois(id: string): Observable<WorkVisit[]> {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/work-visit-cois?id=' + id);
  }

  getWorkVisit(workVisitId: string) {
    return this.httpClient.get<WorkVisit>(environment.baseUrlWs + '/api/work-visit/' + workVisitId);
  }

  cancelWorkVisit(workVisit) {
    return this.httpClient.put<WorkVisit>(environment.baseUrlWs + '/api/work-visit/cancel/' + workVisit.id, {});
  }

  getJiraComments(workVisitId: string) {
    return this.httpClient.get<any[]>(environment.baseUrlWs + '/api/work-visit/jira-comments/' + workVisitId);
  }

  getLatestWorkVisitVisitors() {
    return this.httpClient.get<any>(environment.baseUrlWs + '/api/work-visit/visitors');
  }
}
